module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Joe Layden\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("JOE LAYDEN is a best-selling author and award-winning journalist who regularly covered professional boxing during the height of Mike Tyson's championship reign. He lives in upstate New York.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1XZUro/tc-custom/9781429920537.jpg?1731166583865",
      "alt": "This image is the cover for the book Last Great Fight"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Last Great Fight\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("Meticulously researched, wonderfully written;"), _c('i', [_vm._v(" The Last Great Fight ")]), _vm._v("tells the untold story of a legendary fight and the two warriors who would never be the same again"), _c('br')]), _c('br'), _vm._v("It is considered by many to be the biggest upset in the history of boxing: James \"Buster\" Douglas knocked out then-undefeated Heavyweight Champion Mike Tyson in the 10th round in 1990 when the dominating and intimidating Tyson was considered invincible."), _c('br'), _c('br'), _c('i', [_vm._v("The Last Great Fight")]), _vm._v(" takes readers not only behind the scenes of this epic battle, but inside the lives of two men, their ambitions, their dreams, the downfall of one and the rise of another."), _c('br'), _c('br'), _vm._v("Using his exclusive interviews with both boxers Tyson and Douglas, family members, the referee, the cutmen, trainers and managers to the commentators and HBO staff covering the fight in Tokyo, Joe Layden has crafted a human drama played out on a large stage. This is a compelling tale of shattered dreams and, ultimately, redemption.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    St. Martin’s Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0